import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { catchError, of } from 'rxjs';
import { blank } from '@web/utils';
import { AuthService } from '../services/auth.service';

export const provideUserContext = (): EnvironmentProviders => {
  return provideAppInitializer(() => {
    const auth = inject(AuthService);

    return auth.fetchUserContext().pipe(
      catchError(() => of(void 0)),
      blank(),
    );
  });
};
